import { render } from "./ElementOpacity.vue?vue&type=template&id=b884607e&scoped=true&ts=true"
import script from "./ElementOpacity.vue?vue&type=script&lang=ts"
export * from "./ElementOpacity.vue?vue&type=script&lang=ts"

import "./ElementOpacity.vue?vue&type=style&index=0&id=b884607e&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b884607e"]])

export default __exports__